import { memo } from 'react';

import { TableCell } from '@kc-console/common-ui';

import ExpandButton from './ExpandButton';
import { createBuiltinColumnVariableKeys } from './utils';

export interface DataTableTableBodyExpandCellProps {
  canExpand: boolean;
  depth: number;
  expanded: boolean;
  expandingHidden: boolean;
  hasExpandColumn: boolean;
  onRowExpandingToggle: (rowId: string) => void;
  rowId: string;
  /**
   * `canExpand=false`(확장 비활성)일 때 확장 버튼 hover 시 노출할 툴팁 메시지입니다.
   */
  message?: string;
}

export default memo(function DataTableTableBodyExpandCell(
  props: DataTableTableBodyExpandCellProps,
) {
  const {
    canExpand,
    depth,
    expanded,
    expandingHidden,
    hasExpandColumn,
    message,
    onRowExpandingToggle,
    rowId,
  } = props;

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onRowExpandingToggle(rowId);
  };

  if (!hasExpandColumn) return null;
  return (
    <TableCell
      padding="checkbox"
      size="small"
      sticky
      stickyPosition="left"
      style={{
        left: `var(${createBuiltinColumnVariableKeys('expand').offset})`,
      }}
    >
      {depth === 0 && !expandingHidden && (
        <ExpandButton
          expanded={expanded}
          disabled={!canExpand}
          message={message}
          onClick={handleClick}
        />
      )}
    </TableCell>
  );
});
